import { defineMessage } from "@lingui/core/macro";
import { MessageDescriptor } from "@lingui/core";

export type Weekday =
  | "MONDAY"
  | "TUESDAY"
  | "WEDNESDAY"
  | "THURSDAY"
  | "FRIDAY"
  | "SATURDAY"
  | "SUNDAY";

interface WeekdayWithLabel {
  value: Weekday;
  label: MessageDescriptor;
}

export const weekdays: WeekdayWithLabel[] = [
  { value: "MONDAY", label: defineMessage`Monday` },
  { value: "TUESDAY", label: defineMessage`Tuesday` },
  { value: "WEDNESDAY", label: defineMessage`Wednesday` },
  { value: "THURSDAY", label: defineMessage`Thursday` },
  { value: "FRIDAY", label: defineMessage`Friday` },
  { value: "SATURDAY", label: defineMessage`Saturday` },
  { value: "SUNDAY", label: defineMessage`Sunday` },
];
